import { clsx } from 'clsx'

const VARIANT_STYLES = {
  default: 'border-surface-3',
  success: 'border-success/30',
  danger: 'border-danger/30',
  warning: 'border-warning/30',
} as const

type Variant = keyof typeof VARIANT_STYLES

interface MetricCardProps {
  label: string
  value: string
  sub?: string
  variant?: Variant
}

export function MetricCard({
  label,
  value,
  sub,
  variant = 'default',
}: MetricCardProps): React.JSX.Element {
  return (
    <div className={clsx('rounded-xl border bg-surface-0 p-4 shadow-sm', VARIANT_STYLES[variant])}>
      <p className="text-sm text-text-secondary">{label}</p>
      <p className="mt-1 text-2xl font-semibold text-text-primary">{value}</p>
      {sub && (
        <p
          className={clsx(
            'mt-0.5 text-sm',
            variant === 'danger' ? 'text-danger' : 'text-text-tertiary',
          )}
        >
          {sub}
        </p>
      )}
    </div>
  )
}
